import React, { useState } from 'react'
import Layout from '../../../components/layouts'
import Banner from '../../../components/features/Banner'
import SEO from '../../../components/common/SEO';
import ReactWOW from 'react-wow'
import FeatureCards from "../../../components/features/FeatureCards"

export const query = graphql`
  query Surveys {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`

export default ({ data }) => {
  const [toggler, setToggler] = useState(false)
  const lightboxProps = {
    toggler: toggler,
    setToggler: setToggler,
    sources: ["https://www.youtube.com/watch?v=xE2yXvWB038"],
  }

  const bannerProps = {
    title: 'Surveys',
    subtitle: `Do you ever wonder what workers honestly think of your organization? Well, now you don’t have to! Our Surveys component allows your workers to anonymously share their perception of your organization’s core values, vision, strategy, products, and services. Let them discreetly weigh in on their health and safety, privacy, satisfaction, and motivation to succeed and advance in their workplace.`,
    featureName: 'behaviourObservations',
    rightButtonText: 'Why Certificate Tracking Software?',
    rightButtonSrc: 'https://www.youtube.com/watch?v=xE2yXvWB038',
    mockupImg: '/features/surveys/surveys-header-banner.png'
  }

  const seo = {
    title: 'Workhub | Free Online Employee Survey Tool Anonymous Engagement',
    description: 'Workhubs free online survey tool allows you to capture the voices & opinions of your employees. Create a culture of engagment by creating & sharing surveys with your team.',
    image: '/features/surveys/social-card.jpg',
    // pathname,
    // article
  }

  const featureIndex = [
    {
      title: "Create a Survey",
      para: "Start from one of our templates or create your own to gather feedback from workers. Post statements for workers to rate on a scale of 1-5 stars. ",
    },
    {
      title: "Track Responses",
      para: "Your team can review the rating for individual statements, or the full survey. ",
    },
    {
      title: "Frequency & Trends",
      para: "Select whether a Survey is required Quarterly, Semi-Annually, or Annually and start tracking trends. ",
    },
    {
      title: "Make Improvements",
      para: "Use the data gathered in the surveys to help your team come up with an action plan for improvements. ",
    },
    {
      title: "Answer Honestly",
      para: "Allow workers to submit surveys anonymously to gather quality feedback ratings and comments. ",
    },
  ]

  return (
    <Layout {...lightboxProps}>
      <SEO {...seo} {...data.site} />
      <Banner {...bannerProps} {...lightboxProps} />

      <main className="feature-main">

        <section className="feature-section">
          <div className="container" >
            <div className="row switch-children">

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-right"
                    src="/features/surveys/surveys-cartoon.png"
                    alt="Surveys Admin Computer View"
                  /></ReactWOW>

              </div>


              <div className="col-lg-6 feature-text">
                <h3>Shedding the light on blind spots</h3>

                <p>
                  Blind spots are issues that are known to workers but unknown to leadership. Imagine walking into your boss’s office and telling them you wouldn’t recommend their products, or that you don’t feel safe in the workplace. Yikes!
                </p>
                <p>
                  It’s human nature to avoid offending others, but you risk missing out on valuable feedback if your employees are too shy to speak up or aren’t comfortable sharing their feelings. Surveys offer a discreet place for workers to share their meaningful feedback and allow admins to review those sentiments methodically and fairly.
                </p>
              </div>


            </div>
          </div>
        </section>


        <section className="feature-section">
          <div className="container" >
            <div className="row">


              <div className="col-lg-6 feature-text">

                <h3>If only everything could be this easy…</h3>

                <p>
                  Admins can easily create a survey by selecting a template to use or by building out their own host of questions. The trick is writing statements or questions that workers can agree or disagree with based on their experience or feelings. For example: “Employees are treated fairly regardless of race, gender, religion, sexual orientation, age, or disability.”
                </p>
                <p>
                  Admins can select a frequency for how often each survey is administered (annually, semi-annually, or quarterly), if the survey is required or optional, the positions it’s assigned to, and the number of points awarded for completion if your organization has opted to use our <a target="_blank" href="https://www.workhub.com/features/rewards/">Rewards program</a> .
                </p>
              </div>

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInRight" delay="0.9s">

                  <img
                    className="feature-img-left"
                    src="/features/surveys/surveys-admin-tablet-average.png"
                    alt="Surveys Admin Tablet View"
                  />

                </ReactWOW>

              </div>

            </div>
          </div>
        </section>



        <section className="feature-section">
          <div className="container" >
            <div className="row switch-children">

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-right"
                    src="/features/surveys/surveys-admin-tablet.png"
                    alt="Surveys Admin Tablet Chart View"
                  />
                </ReactWOW>

              </div>


              <div className="col-lg-6 feature-text">

                <h3>Using a 5-star system to illuminate the darkness</h3>
                
                <p>
                  Once assigned, your survey can be filled out by your chosen workers. They can rate each statement or question from one start (strongly disagree) to five stars (strongly agree). Workhub tracks participation in the survey, allowing workers once response per survey each survey period. Responses are completely anonymous, while comments allow workers to post as themselves or anonymously, providing a safe way for your workers to be honest with you.
                </p>
                <p>
                  After the survey period closes, scores are added for each question and a survey average is calculated. Comments will become available and you can review your team’s overall sentiments. You can share or hide comments, respond to comments, or create action items to address concerns.  Detail charts and line graphs of responses over time will highlight trends, giving you insight into your workers' ongoing opinion.
                </p>
              </div>
            </div>
          </div>
        </section>



        <section className="feature-section">
          <div className="container">
            <div className="row">

              <div className="col-lg-6 feature-text">

                <h3>Do you read me? Loud and clear!</h3>

                <p>
                  Works can filter between optional and required surveys, prioritizing where and how they respond. They will be able to see the score for the previous periods and read any shared comments from others, giving them an idea of how their colleagues feel and where improvements are being made. Transparency about progress helps increase trust within your organization - everyone’s on the same team and working towards the same goal!
                </p>
              </div>

              <div className="col-lg-6 feature-img">

                <ReactWOW animation="fadeInLeft" delay="0.9s">
                  <img
                    className="feature-img-left"
                    src="/features/surveys/surveys-worker-mobile.png"
                    alt="Surveys Admin Mobile View"
                  />
                </ReactWOW>

              </div>


            </div>
          </div>
        </section>
      </main>

      <section className="feature-overview-container">
          <h2>Overview</h2>

          <div className="feature-overview-grid" style={{marginBottom: '60px'}}>
            {featureIndex.map(item => (
              <FeatureCards title={item.title} para={item.para} />
            ))}
          </div>
        </section>
      

    </Layout>
  )
}